import React, { useRef, useState } from "react";
import Slider from "react-slick";
import classnames from "classnames";

import { Wrapper } from "../../Wrapper";
import { getResizedImageURL } from "../../utils";
import styles from "../styles/GalleryWidget.module.scss";

export const GalleryWidget = ({ data }: any) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const sliderMain = useRef<Slider>(null);
  const sliderNav = useRef<Slider>(null);

  const numberOfSlides = data.images.length;

  const sliderSettings = { infinite: false };

  const mainSliderSettings = {
    ...sliderSettings,
    beforeChange: (_: any, nextIndex: number) => {
      if (sliderNav.current) {
        setCurrentSlideIndex(nextIndex);
        sliderNav.current.slickGoTo(nextIndex);
      }
    },
    nextArrow: <Arrow isDisabled={currentSlideIndex === numberOfSlides - 1} />,
    prevArrow: <Arrow isPrev isDisabled={currentSlideIndex === 0} />,
  };

  const navSliderSettings = {
    ...sliderSettings,
    arrows: false,
    slidesToShow: numberOfSlides >= 4 ? 4 : numberOfSlides,
    swipeToSlide: true,
    beforeChange: (_: any, nextIndex: number) => {
      if (sliderMain.current) {
        sliderMain.current.slickGoTo(nextIndex);
      }
    },
  };

  return (
    <Wrapper>
      <div className={styles.gallery}>
        <Slider ref={sliderMain} {...mainSliderSettings}>
          {data.images.map((image: any, index: number) => {
            const imgURL = getResizedImageURL(image.url, 1520);
            return (
              <div key={index} className={styles.slideWrapper}>
                <div
                  className={styles.slide}
                  title={image.alt}
                  style={{
                    backgroundImage: `url(${imgURL})`,
                  }}
                />
              </div>
            );
          })}
        </Slider>
        <Slider ref={sliderNav} {...navSliderSettings}>
          {data.images.map((image: any, index: number) => {
            const imgURL = getResizedImageURL(image.url, 1520);
            return (
              <div
                className={classnames(styles.slideThumbnailWrapper, {
                  [styles.slideThumbnailWrapperActive]:
                    index === currentSlideIndex,
                  [styles.slideThumbnailWrapperLast]:
                    index === numberOfSlides - 1,
                })}
                key={"nav" + index}
                onClick={(e) => {
                  e.currentTarget.blur();
                  if (sliderMain.current) {
                    sliderMain.current.slickGoTo(index);
                  }
                }}
              >
                <div
                  className={styles.slideThumbnail}
                  title={image.alt}
                  style={{
                    backgroundImage: `url(${imgURL})`,
                  }}
                />
              </div>
            );
          })}
        </Slider>
      </div>
    </Wrapper>
  );
};

const Arrow = ({ isPrev, isDisabled, className, onClick }: any) => (
  <button
    className={classnames(className, styles.arrow, {
      [styles.arrowPrev]: isPrev,
      [styles.arrowDisabled]: isDisabled,
    })}
    onClick={(e) => {
      e.currentTarget.blur();
      onClick(e);
    }}
  />
);
